import { render, staticRenderFns } from "./speciaDBManage.vue?vue&type=template&id=8905750e"
import script from "./speciaDBManage.vue?vue&type=script&lang=js"
export * from "./speciaDBManage.vue?vue&type=script&lang=js"
import style0 from "./speciaDBManage.vue?vue&type=style&index=0&id=8905750e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports